var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"opacity":"0.5","color":"red","spinner-variant":"primary"}},[_c('Header'),_c('div',{staticClass:"router-view-wrapper"},[_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }